
import React, {Component} from "react"

import { FormGroup } from '../component/form';
import { Loading } from '../component/BaseComponent';
import { HttpsRequest } from '../component/Utils';
// import { createSearchParams } from "react-router-dom";
import {Link } from 'react-router-dom'; 

import {SideView, MainViewWrapper} from "./loginui" ; 
import { APIRoute, APPRoute, RespStatus } from "../component/texts";



class SignupUi extends Component<IProps, IState> {

    constructor(props: IProps){

        super(props)
        this.state = {
            form: [],
            isbusy: true,
            data: {},
            redirect: false,
            redirect_url: "",
            redirect_data: []  
        }
    }

    render(){
 
        const year = new Date().getFullYear();

        return (

            <div className="row">
                <SideView /> 
                <div className="col-md-7 posrel"> 
                <MainViewWrapper>
                <div className="padh10 mt2">
                     
                    <div className='mbt5'>                        
                        <div className="d-flex justify-content-between align-items-center">
                            <h3> Register </h3>           
                            <Link to={APPRoute.login} className='nodecor'>              
                                <span className='text-muted'> Already have an account? </span> &nbsp; Sign In
                            </Link>
                        </div>
                  </div>

                    <form method='post' autoComplete="off" onSubmit={this.submit_data}>
                        {
                        this.state.form.map((fld, idx) => {
                            return <FormGroup
                            key={`sign${idx}`}
                            obj={fld} 
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.onchange(e);                                
                            }}
                            />;
                        })
                        }
                        
                        <div className="d-grid mb-4 mt-4 padv5">
                            <button type="submit" className="btn btn-primary btn-lg">
                                Sign Up
                            </button>
                        </div>

               
                    </form>
                </div>

                {this.state.isbusy && <Loading />}

                </MainViewWrapper>
                </div>
            </div>
        )

    }

    initfunc = ()=> {
    
        HttpsRequest.get(APIRoute.signup, this.get_resp);

    }

    get_resp = ({ body }: RespArgs) => {

        this.setState({
            form: body['form'],
            isbusy: false
        });
          
    }

    onchange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {

        const name: string = target.name;
        const value: string = target.value;
        const checked: boolean = target.checked;
        const type: string = target.type;
        
        const {data} = this.state ; 
        
        
        if (type === 'checkbox') {
            this.setState({ data: Object.assign({}, data, { [name]: checked }) });
            return;
        }
      
        this.setState({ data: Object.assign({}, data, { [name]: value }) });

    }

    componentDidMount(): void {
        this.initfunc()
    }

    submit_data = (event: React.SyntheticEvent<HTMLFormElement>) => {

        event.preventDefault();
        const { data } = this.state; 

        const error_handler = (r: RespArgs) => {
            this.setState({isbusy: false});
        }

        console.log(data);
        HttpsRequest.post(APIRoute.signup, data, this.post_resp, {}, error_handler);
        this.setState({ isbusy: true });
    }

    post_resp = ({status, status_msg, body}: RespArgs) => {
        
        if (status === RespStatus.success ){
            this.setState({
                isbusy: false,
            }, () => {
              
                this.props.navigate(
                    APPRoute.otp, 
                    {
                        state:{form: body.otpform, email: body.email },                        
                    }
                ) 
             })
        } else if (status === RespStatus.failed) {
            this.setState({isbusy:false, form: body.form}) 
        }

    }

}


export default SignupUi 